// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"
import Swiper, { Navigation, Pagination, Autoplay, FreeMode } from 'swiper';

export default class CarouselController extends AdvancedController {

  static targets = [
    "wrapper"
  ];

  static values = {
    // exampleString: String,
    // exampleDefault: { type: Number, default: 42 },
  }

  connect() {
    super.connect(...arguments)
    const config = {
      modules: [Autoplay, FreeMode],
      spaceBetween: 32,
      grabCursor: true,
      a11y: false,
      freeMode: true,
      simulateTouch: false,
      speed: 5000,
      grabCursor: false,
      loop: true,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      }
    }
    new Swiper(this.wrapperTarget, config)
  }

}
